export const stringMapDefault = {
    searchLabelText: "Search",
    clearTooltipText: "Clear"
};
